import { extendTheme } from '@chakra-ui/react';

const theme = extendTheme({
  fonts: {
    heading: `'Outfit', 'Wix Madefor Text', sans-serif`,
    body: `'Wix Madefor Text', sans-serif`,
  },
  colors: {
    brand: {
      50: '#ECFEFF',
      100: '#CFFAFE',
      200: '#A5F3FC',
      300: '#67E8F9',
      400: '#22D3EE',
      500: '#0891B2',
      600: '#0E7490',
      700: '#155E75',
      800: '#164E63',
      900: '#083344',
    },
    slate: {
      50: '#F8FAFC',
      100: '#F1F5F9',
      200: '#E2E8F0',
      300: '#CBD5E1',
      400: '#94A3B8',
      500: '#64748B',
      600: '#475569',
      700: '#334155',
      800: '#1E293B',
      900: '#0F172A',
    },
    accent: {
      50: '#FFFBEB',
      100: '#FEF3C7',
      200: '#FDE68A',
      300: '#FCD34D',
      400: '#FBBF24',
      500: '#F59E0B',
      600: '#D97706',
    },
  },
  shadows: {
    soft: '0 4px 24px -4px rgba(15, 23, 42, 0.08)',
    card: '0 8px 32px -8px rgba(15, 23, 42, 0.12)',
    nav: '0 1px 0 rgba(15, 23, 42, 0.06)',
  },
  radii: {
    xl: '1rem',
    '2xl': '1.25rem',
  },
  styles: {
    global: {
      'html, body': {
        bg: 'slate.50',
        color: 'slate.800',
      },
      '*::selection': {
        bg: 'brand.100',
        color: 'brand.800',
      },
    },
  },
  components: {
    Button: {
      baseStyle: {
        fontWeight: '600',
        borderRadius: 'lg',
      },
      defaultProps: {
        colorScheme: 'brand',
      },
    },
    Input: {
      defaultProps: {
        focusBorderColor: 'brand.500',
      },
      variants: {
        outline: {
          field: {
            bg: 'white',
            borderColor: 'slate.200',
            _hover: { borderColor: 'slate.300' },
          },
        },
      },
    },
    Select: {
      defaultProps: {
        focusBorderColor: 'brand.500',
      },
    },
    Textarea: {
      defaultProps: {
        focusBorderColor: 'brand.500',
      },
    },
    Tabs: {
      variants: {
        'soft-pill': {
          tablist: {
            bg: 'slate.100',
            p: 1,
            borderRadius: 'xl',
            display: 'inline-flex',
          },
          tab: {
            borderRadius: 'lg',
            fontWeight: '600',
            color: 'slate.600',
            _selected: {
              bg: 'white',
              color: 'brand.700',
              boxShadow: 'soft',
            },
          },
        },
      },
    },
    Modal: {
      baseStyle: {
        dialog: {
          borderRadius: '2xl',
          overflow: 'hidden',
        },
      },
    },
    Table: {
      variants: {
        modern: {
          table: {
            borderCollapse: 'separate',
            borderSpacing: 0,
          },
          th: {
            bg: 'slate.50',
            color: 'slate.500',
            fontSize: 'xs',
            fontWeight: '700',
            textTransform: 'uppercase',
            letterSpacing: '0.05em',
            borderBottom: '1px solid',
            borderColor: 'slate.100',
            py: 3,
            whiteSpace: 'nowrap',
          },
          td: {
            borderBottom: '1px solid',
            borderColor: 'slate.50',
            py: 3.5,
            fontSize: 'sm',
            color: 'slate.700',
          },
          tr: {
            _hover: {
              bg: 'brand.50',
            },
            _last: {
              td: { borderBottom: 'none' },
            },
          },
        },
      },
    },
    Badge: {
      baseStyle: {
        borderRadius: 'md',
        px: 2,
        py: 0.5,
        fontWeight: '600',
        textTransform: 'none',
      },
    },
  },
});

export default theme;
